import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Haanit Single Story" mdxType="SEO" />
    <h3 {...{
      "id": "haanit-ch1"
    }}>{`Haanit Ch.1`}</h3>
    <p>{`Sell `}<strong parentName="p">{`2 Olives`}</strong>{`, buy `}<strong parentName="p">{`Wolf’s Bow`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Both provokes: Defend, Forest Fox x3`}</p>
    <p>{`Capture `}<strong parentName="p">{`Forest Fox`}</strong>{` in `}<strong parentName="p">{`Whisperwood`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Heal before boss if not full HP.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ghisarma"
      }}>{`Ghisarma`}</h4>
      <ol>
        <li parentName="ol">{`Forest Fox`}</li>
        <li parentName="ol">{`Forest Fox`}</li>
        <li parentName="ol">{`True Strike x4`}</li>
        <li parentName="ol">{`Attack`}</li>
        <li parentName="ol">{`Grape`}</li>
        <li parentName="ol">{`Attack`}</li>
        <li parentName="ol">{`True Strike x4`}</li>
        <li parentName="ol">{`Forest Fox`}</li>
        <li parentName="ol">{`Forest Fox`}</li>
        <li parentName="ol">{`Rain of Arrows`}</li>
        <li parentName="ol">{`True Strike x4`}</li>
      </ol>
    </Battle>
    <p>{`Head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`, kill Cait with Rain of Arrows.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <p>{`Haanit: Arrowstorm, `}<strong parentName="p">{`Scholar`}</strong>{`, Firestorm, Lightning Blast`}</p>
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <p>{`Haanit: Evasive Maneuvers`}</p>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Rippletide`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light S`}</strong>{`, `}<strong parentName="p">{`$1200`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light M`}</strong>{`, reset steps, tag `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch2-start"
    }}>{`Haanit Ch.2 Start`}</h3>
    <p>{`Exit and go towards `}<strong parentName="p">{`Runeblade`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`, enter `}<strong parentName="p">{`Runeblade`}</strong>{`. Pick `}<strong parentName="p">{`$50000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Light L`}</p>
    <p>{`Finish chapter, TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Wind M`}</strong>{` and exit.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. S&Q at save, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`S'warkii`}</strong>{`, and go to `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`Light M battle in Ravus Manor`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "heathcote"
      }}>{`Heathcote`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Last person on T2: Defend`}</li>
        <li parentName="ul">{`Others: Bow / Dagger x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`First person: Bow / Dagger x3`}</li>
        <li parentName="ul">{`Others: Wind M & Ice M`}</li>
      </ul>
    </Battle>
    <p>{`Steal `}<strong parentName="p">{`Pom S & Nourish S`}</strong>{`.`}</p>
    <p>{`Run to `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <h4 {...{
      "id": "stillsnow"
    }}>{`Stillsnow`}</h4>
    <ol>
      <li parentName="ol">{`Buy `}<strong parentName="li">{`Ice M`}</strong>{`.`}</li>
      <li parentName="ol">{`Buy `}<strong parentName="li">{`Shadow M`}</strong>{`.`}</li>
      <li parentName="ol">{`Buy `}<strong parentName="li">{`Empowering Ring`}</strong>{`.`}</li>
      <li parentName="ol">{`Buy `}<strong parentName="li">{`Fire M & Fire S`}</strong>{`.`}</li>
      <li parentName="ol">{`Pick `}<strong parentName="li">{`Shadow M`}</strong>{`.`}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`. Run towards `}<strong parentName="p">{`Marsalim`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$20000, Thunder L`}</strong>{`. Enter `}<strong parentName="p">{`Marsalim Catacombs`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Viper Dagger`}</strong>{`, `}<strong parentName="p">{`Master Spear`}</strong>{` and exit. Enter `}<strong parentName="p">{`Marsalim`}</strong>{`.`}</p>
    <h4 {...{
      "id": "marsalim"
    }}>{`Marsalim`}</h4>
    <ol>
      <li parentName="ol">{`Buy `}<strong parentName="li">{`Pom L`}</strong>{`.`}</li>
      <li parentName="ol">{`Buy `}<strong parentName="li">{`3 L Stones`}</strong>{`.`}</li>
      <li parentName="ol">{`Pick `}<strong parentName="li">{`Tempest Amulet`}</strong>{`.`}</li>
      <li parentName="ol">{`Pick `}<strong parentName="li">{`Enchanted Circlet, High House Armor, $25000`}</strong>{`.`}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch2-continued"
    }}>{`Haanit Ch.2 Continued`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <p>{`Haanit: -Wolf Bow +Enchanted Circlet +High House Armor +Empowering Ring`}</p>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Nourish S: Haanit`}</li>
        <li parentName="ul">{`Grape: Haanit`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "nathans-bodyguard"
      }}>{`Nathan's Bodyguard`}</h4>
      <ol>
        <li parentName="ol">{`Fire S`}</li>
        <li parentName="ol">{`Fire M`}</li>
        <li parentName="ol">{`Fire L`}</li>
        <li parentName="ol">{`Shadow L`}</li>
      </ol>
    </Battle>
    <p>{`Buy `}<strong parentName="p">{`Fire L`}</strong>{`. Grape Haanit.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$5000`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ancient-one"
      }}>{`Ancient One`}</h4>
      <ol>
        <li parentName="ol">{`Fire L`}</li>
        <li parentName="ol">{`Ice M`}</li>
        <li parentName="ol">{`Shadow M`}</li>
      </ol>
    </Battle>
    <p>{`Pick `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Haanit: `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold, `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep + Donate BP`}</li>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lord-of-the-forest"
      }}>{`Lord of the Forest`}</h4>
      <blockquote>
        <p parentName="blockquote">{`I assume Merchant 2 Defends here, and Axe can be Mercs.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Haanit: Axe`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Merchant 1: HHV x3`}</li>
        <li parentName="ul">{`Merchant 2: HHB x3`}</li>
        <li parentName="ul">{`Therion: Pom M Merchant 2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Merchant 1/Therion: Pom S Merchant 2`}</li>
        <li parentName="ul">{`Merchant 2: HHV x4`}</li>
      </ul>
    </Battle>
    <p>{`Buy `}<strong parentName="p">{`Shadow L & Light L`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Sidestep, `}<strong parentName="li">{`Scholar`}</strong>{`, Firestorm`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Merchant`}</strong>{`, Sidestep + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Haanit: EI + Heightened Senses`}</li>
        <li parentName="ul">{`Tressa: EI`}</li>
        <li parentName="ul">{`Therion: EI`}</li>
      </ul>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Shadow M`}</strong>{`.`}</p>
    <p>{`Finish chapter & TP `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch3"
    }}>{`Haanit Ch.3`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "shop---sell"
      }}>{`Shop - Sell`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
        <li parentName="ul">{`Master Spear`}</li>
        <li parentName="ul">{`Viper Dagger`}</li>
        <li parentName="ul">{`Wolf Bow`}</li>
        <li parentName="ul">{`Olive L`}</li>
        <li parentName="ul">{`Refreshing Jam`}</li>
        <li parentName="ul">{`Tempest Amulet`}</li>
      </ul>
      <p><em parentName="p">{`Need `}<strong parentName="em">{`$72548`}</strong>{` assuming no HH usage getting to Dragon.`}</em></p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "alaic"
      }}>{`Alaic`}</h4>
      <ol>
        <li parentName="ol">{`Shadow L`}</li>
        <li parentName="ol">{`Shadow M`}</li>
        <li parentName="ol">{`Shadow M`}</li>
        <li parentName="ol">{`Shadow L`}</li>
      </ol>
    </Battle>
    <p>{`Pick `}<strong parentName="p">{`$15000`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dragon"
      }}>{`Dragon`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Tressa/Therion Turn order T2 changes fight.`}<br parentName="p"></br>{`
`}{`Notation will be Tressa 1st / Therion 1st`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Haanit: Defend`}</li>
        <li parentName="ul">{`Tressa: Light S`}</li>
        <li parentName="ul">{`Therion: AC x2 / Pom L Tressa`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Haanit: Axe x3`}</li>
        <li parentName="ul">{`Tressa: Pom L Therion / HHV x4`}</li>
        <li parentName="ul">{`Therion: HHV x3 / AC`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: HHVxMAX`}</li>
        <li parentName="ul">{`Therion: HHVxMAX`}</li>
      </ul>
    </Battle>
    <p>{`Go to shop, buy `}<strong parentName="p">{`Olive M`}</strong>{` & `}<strong parentName="p">{`Herb of Revival`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Lightning Blast`}</li>
        <li parentName="ul">{`Therion: HP Thief`}</li>
      </ul>
    </Menu>
    <p>{`Finish chapter, TP `}<strong parentName="p">{`Marsalim`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch4"
    }}>{`Haanit Ch.4`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Pom L`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Fire L`}</strong>{` if no L Stone dupes.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$30000`}</strong>{`, `}<strong parentName="p">{`$50000`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "redeye"
      }}>{`Redeye`}</h4>
      <h5 {...{
        "id": "weaknesses"
      }}>{`Weaknesses`}</h5>
      <ol>
        <li parentName="ol">{`Dagger, Bow, Staff, Fire, Light`}</li>
        <li parentName="ol">{`Spear, Axe, Lightning, Wind, Light`}</li>
        <li parentName="ol">{`Sword, Bow, Fire, Lightning, Light`}</li>
      </ol>
    </Battle>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      